import { Button } from '../../../../Button/Button';

type BackToGameProps = {
  currentGameId: string;
};

function BackToGame({ currentGameId }: BackToGameProps) {
  return (
    <div className="mb-2 p-3">
      <Button type="link" to={`/game/${currentGameId}`} className="w-full">
        Zurück zum Spiel
      </Button>
    </div>
  );
}

export default BackToGame;
